
<template>
    <div ref="listWrap">
        <wrapper-list
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="优惠券名称" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_name" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                    <FormItem label="领取人" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_userName" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import CellBar from '@/components/paas/cell-bar' //列表内操作
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList  ,CellBar},
        data() {
            return {
                serviceUrl:"/member/coupon/use/record",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_name:"",
                    queryOrderBy_:"createTime@Desc",
                    query_LIKE_userName:"",
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '名称',
                        key: 'name',
                    },
                    {
                        title: '订单号',
                        key: 'orderCode',
                    },
                    {
                        title: '领取时间',
                        key: 'createTime',
                    },
                    {
                        title: '领取人',
                        key: 'userName',
                    },
                    {
                        title: '使用时间',
                        key: 'timeUse',
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            return h(CellBar,
                                {
                                    props:{
                                        show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
                                    },
                                    //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                                    on: {

                                        'delete':()=>{
                                            this.$nextTick(()=>{
                                                this.paasDeleteOper(params.row[this.currentIdFiledName]);
                                            })
                                        },

                                    }
                                }
                            )
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
        }
    }
</script>
